import { CampaignIdBadge } from 'modules/campaigns/lib/components/CampaignIdBadge';
import { AttributionMode } from 'modules/workflows/types';

export const CHILD_VALUE_LOOKUP = {
  [AttributionMode.ExplicitlySet]: <CampaignIdBadge />,
  [AttributionMode.AttributionPeriod]: 'set period',
  [AttributionMode.LastMessaged]: 'set period',
};
